import React from 'react'

function CategoriasMercadoItem(props) {
  return (
    <div
      className='caja'
      id={props.category.id}
      key={props.key}
      onClick={() => props.editCategory(props.category)}
    >
      {props.category.category}
    </div>
  )
}

export {CategoriasMercadoItem}
